

/* eslint-disable import/no-unresolved */
const base = require('base/components/footer');
const preHome = require('onestic-base/components/preHome');
const lozad = require('lozad');
const utils = require('../utils');

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}


module.exports = {
    base,
    loadCountriesLanguages() {
        const prehomeContent = $('#prehomecontent');
        if (prehomeContent.length) {
            const loadPrehomeUrl = prehomeContent.attr('data-url');
            if (loadPrehomeUrl) {
                $.ajax({
                    url: loadPrehomeUrl,
                    method: 'GET',
                }).done((data) => {
                    if (data.renderedTemplate) {
                        prehomeContent.html('').append(data.renderedTemplate);

                        const countries = $('#countrySite');
                        const languages = $('#language');
                        if (countries.length) {
                            const footerCountriesComponent = $('.countriesFooter');
                            if (footerCountriesComponent.length) {
                                const country = utils.getCookie('countryAndState');
                                if (country) {
                                    const countriesFooter = countries.clone().attr('id', 'countrySiteFooter');
                                    footerCountriesComponent.append(countriesFooter);
                                    footerCountriesComponent.find(`option[value='${country.toLowerCase()}']`).prop('selected', true);
                                }
                            }
                        }
                        if (languages.length) {
                            const footerLanguagesComponent = $('.languagesFooter');
                            if (footerLanguagesComponent.length) {
                                const locale = utils.getCookie('locale');
                                if (locale) {
                                    const languagesFooter = languages.clone().attr('id', 'languageFooter');
                                    footerLanguagesComponent.append(languagesFooter);
                                    footerLanguagesComponent.find(`option[value='${locale.toLowerCase()}']`).prop('selected', true);
                                    footerLanguagesComponent.find('option').each((index, option) => {
                                        const homeUrl = $(option).attr('data-urlhome');
                                        $(option).attr('data-url', homeUrl);
                                    });
                                }
                            }
                        }

                        preHome.loadSelector();
                        triggerLozad();
                    }
                });
            }
        }
    },

};
